export function exercicesClotures(lsExercices) {
    return lsExercices.filter(exercice => exercice.Etat > 0);
}

export function exerciceCourant(lsExercices) {
    return lsExercices.filter(exercice => exercice.Etat === 0)[0];
}

export function exercicesFuturs(lsExercices) {
    return lsExercices.filter(exercice => exercice.Etat < 0);
}

//order by datedeb asc et prendre premier
export function exerciceSuivant(lsExercices) {
    return lsExercices.filter(exercice => exercice.Etat < 0)[0];
}

export function exercicesNonClotures(lsExercices) {
    return lsExercices.filter(exercice => exercice.Etat <= 0);
}

export function indexExeCourant(lsExercices) {
    const exeCourant = (exe) => exe.Etat === 0;
    return lsExercices.findIndex(exeCourant)
}


// WEBPACK FOOTER //
// ./src/App_Code/ExeComptable.js